import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material'
import SlideDownTransition from '../../../../../hooks/Ui/Transition'
import { ApprovalPopupProps } from './props'
import useApprovalPopupViewModel from './viewModel'
import { ApprovalStatus } from '../../../../../database/enums/ApprovalStatus.enum'

export default function ApprovalPopup(props: ApprovalPopupProps) {
  const viewModel = useApprovalPopupViewModel(props)
  const actionLabel = viewModel.approvalStatus === ApprovalStatus.APPROVED ? 'Approve' : 'Reject'
  const actionColor = viewModel.approvalStatus === ApprovalStatus.APPROVED ? 'success' : 'error'

  if (!!viewModel.data && !!viewModel.approvalStatus)
    return (
      <Dialog
        open={viewModel.open}
        slots={{ transition: SlideDownTransition }}
        keepMounted
        onClose={viewModel.onClose}
        aria-describedby='admin-leave-request-approval-popup'
        maxWidth={'xs'}
      >
        <DialogTitle>{`${actionLabel} this leave request?`}</DialogTitle>
        <DialogContent>
          <DialogContentText>
            {`This action will also send notification email to ${viewModel.data.email}.`}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={viewModel.onClose}>Cancel</Button>
          <Button
            variant='contained'
            color={actionColor}
            disabled={viewModel.isLoading}
            loading={viewModel.isLoading}
            onClick={viewModel.onConfirm}
          >
            {actionLabel}
          </Button>
        </DialogActions>
      </Dialog>
    )
  return null
}
